<!--院内资产-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="head-box">
                <div class="title-name">{{ dimension == 1 ? '院内' : '门诊' }}资产(元)</div>
                <div class="assets flex-y-center">
                    <div class="amount">{{ storageAssetsList.storePropertyAmount || 0 }}万</div>
                    <div class="detail-box flex-y-center" @click="toDetail()">
                        <div class="detail-name">客户资产明细</div>
                        <van-icon name="arrow" class="head-arrow" />
                    </div>
                </div>
            </div>
            <div class="head-chart">
                <div ref="headchart" id="headchart"></div>
            </div>
            <div class="interval"></div>
            <div class="date-box  flex-row  flex-between">
                <div class="date">
                    <div class="arrow-box">
                        <div class="arrow-l" @click="handleCalendar('prev')"></div>
                    </div>
                    <div>{{ year }}年</div>
                    <div class="arrow-box">
                        <div class="arrow-r" @click="handleCalendar('next')"></div>
                    </div>
                </div>
                <div v-if="nowyear == year" class="updatetime">数据更新至{{ updateTime }}</div>
            </div>
            <div class="table-list">
                <div class="table-header flex-y-center flex-between">
                    <div class="header-title ">月份</div>
                    <div class="header-title header-title-ml70 flex-1">销售额(万)</div>
                    <div class="header-title header-title-ml35 flex-1">消费额(万)</div>
                    <div class="header-title header-title-ml35 flex-1">消费/销售比</div>
                </div>
                <div class="data-list-box" v-if="sellMonthAmountData.length > 0">
                    <div :class="` data-list line flex-y-center  ${index + 1 != sellMonthAmountData.length ? 'tr-bottom' : ''}`" v-for="(item, index) in sellMonthAmountData" :key="index">
                        <div class="header-title Blacks">
                            <div>{{ item.month }}月</div>
                        </div>
                        <div class=" header-title header-title-ml70 flex-1 Blacks">
                            <div>{{ item.saleAmount }}</div>
                        </div>
                        <div class="header-title header-title-ml35 flex-1 Blacks">
                            <div>{{ item.consumeAmount }}</div>
                        </div>
                        <div class="header-title  header-title-ml35 flex-1 Blacks">
                            <div :class="`${item.showRed ? 'fc' : ''}`">{{ item.ratioDesc }}</div>
                        </div>
                    </div>
                    <div class="total">
                        <div class="total-tr line  flex-y-center">
                            <div class="total-td">
                                <div>合计</div>
                            </div>
                            <div class="total-td  header-title-ml70 flex-1">
                                <div>{{ totalAmountData.totalSaleAmount }}</div>
                            </div>
                            <div class="total-td  header-title-ml35 flex-1">
                                <div>{{ totalAmountData.totalConsumeAmount }}</div>
                            </div>
                            <div class="total-td  header-title-ml35 flex-1">
                                <div :class="`${totalAmountData.showRed ? 'fc' : ''}`">{{ totalAmountData.ratioDesc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { timestampToYestoday, getYear } from '@/utils/validate';
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "storageAssetsHome",
        inject: ['reload'],
        components: {
            Picker
        },
        data() {
            return {
                nowyear: getYear(),   //获取当前年
                year: "",
                storageAssetsList: [],
                sellMonthAmountData: [],
                totalAmountData: [],    //合计院余资产
                refreshing: false,
                updateTime: timestampToYestoday(),   //更新时间
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                dimension: 0, //区分生美医美 1 生美 2 医美

            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension

            if (this.dimension == 1) {
                document.title = '院内资产'
            } else {
                document.title = '门诊资产'
            }
            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        this.$router.replace({
                            name: "storageAssetsRegionPage"
                        });
                    }
                }
                this.onLoad();
                this.initdateData();
            })
        },
        methods: {
            // 初始化时间
            initdateData() {
                var date = new Date();
                var year = date.getFullYear();
                this.year = year;
                this.getSellAmountData();
            },
            //资产饼图加载
            onLoad() {
                const _this = this

                this.getDetail().then(() => {
                    let data = []
                    let radius = []
                    if (this.dimension == 1) {
                        data = [
                            { value: this.storageAssetsList.lifeServiceAmount, name: '{c|生美护理 >\n' + this.storageAssetsList.lifeServiceAmount + '万 \n' + this.storageAssetsList.lifeServiceRate + '%}', itemStyle: { color: '#72d8db' } },
                            { value: this.storageAssetsList.lifeProductAmount, name: '{c|生美产品 >\n' + this.storageAssetsList.lifeProductAmount + '万 \n' + this.storageAssetsList.lifeProductRate + '%}', itemStyle: { color: '#f56d41' } },
                            { value: this.storageAssetsList.lifeCardBalanceAmount, name: '{c|卡余 >\n' + this.storageAssetsList.lifeCardBalanceAmount + '万 \n' + this.storageAssetsList.lifeCardBalanceRate + '%}', itemStyle: { color: '#a8bdfe' } },
                            { value: this.storageAssetsList.liftCouponAmount, name: '{c|券余 >\n' + this.storageAssetsList.liftCouponAmount + '万 \n' + this.storageAssetsList.liftCouponRate + '%}', itemStyle: { color: '#f9b59f' } },
                            { value: this.storageAssetsList.medicalAmount, name: '{c|医美/抗衰 >\n' + this.storageAssetsList.medicalAmount + '万 \n' + this.storageAssetsList.medicalRate + '%}', itemStyle: { color: '#5778ff' } }
                        ]
                        radius = ['35%', '60%']
                    } else if (this.dimension == 2) {
                        data = [
                            { value: this.storageAssetsList.shouShuAmountObj.amount, name: '{c|手术 >\n' + this.storageAssetsList.shouShuAmountObj.amount + '万 \n' + this.storageAssetsList.shouShuRate + '%}', itemStyle: { color: '#F56C40' }, type: this.storageAssetsList.shouShuAmountObj.value },
                            { value: this.storageAssetsList.fuSeGuanLiAmountObj.amount, name: '{c|肤色管理 >\n' + this.storageAssetsList.fuSeGuanLiAmountObj.amount + '万 \n' + this.storageAssetsList.fuSeGuanLiRate + '%}', itemStyle: { color: '#AC5D5D' }, type: this.storageAssetsList.fuSeGuanLiAmountObj.value },
                            { value: this.storageAssetsList.fuZhiGuanLiAmountObj.amount, name: '{c|肤质管理 >\n' + this.storageAssetsList.fuZhiGuanLiAmountObj.amount + '万 \n' + this.storageAssetsList.fuZhiGuanLiRate + '%}', itemStyle: { color: '#F9B59F' }, type: this.storageAssetsList.fuZhiGuanLiAmountObj.value },
                            { value: this.storageAssetsList.fuHeWeiZhengAmountObj.amount, name: '{c|复合微整 >\n' + this.storageAssetsList.fuHeWeiZhengAmountObj.amount + '万 \n' + this.storageAssetsList.fuHeWeiZhengRate + '%}', itemStyle: { color: '#484EA7' }, type: this.storageAssetsList.fuHeWeiZhengAmountObj.value },
                            { value: this.storageAssetsList.wuChuangTiLaAmountObj.amount, name: '{c|无创提拉 >\n' + this.storageAssetsList.wuChuangTiLaAmountObj.amount + '万 \n' + this.storageAssetsList.wuChuangTiLaRate + '%}', itemStyle: { color: '#5678FF' }, type: this.storageAssetsList.wuChuangTiLaAmountObj.value },
                            { value: this.storageAssetsList.shenTiSuXingAmountObj.amount, name: '{c|身体塑型 >\n' + this.storageAssetsList.shenTiSuXingAmountObj.amount + '万 \n' + this.storageAssetsList.shenTiSuXingRate + '%}', itemStyle: { color: '#A8BCFE' }, type: this.storageAssetsList.shenTiSuXingAmountObj.value },
                            { value: this.storageAssetsList.ymCouponAmountObj.amount, name: '{c|券余 >\n' + this.storageAssetsList.ymCouponAmountObj.amount + '万 \n' + this.storageAssetsList.ymCouponRate + '%}', itemStyle: { color: '#72D8DB' }, type: this.storageAssetsList.ymCouponAmountObj.value },
                            { value: this.storageAssetsList.ymCouponAmountObj.amount, name: '{c|未分类 >\n' + this.storageAssetsList.otherAmountObj.amount + '万 \n' + this.storageAssetsList.otherRate + '%}', itemStyle: { color: '#51f329' }, type: this.storageAssetsList.otherAmountObj.value }
                        ]
                        radius = ['30%', '53%']
                    } else if (this.dimension == 3) {
                        data = [
                            { value: this.storageAssetsList.ksCouponAmountObj.amount, name: '{c|' + this.storageAssetsList.ksCouponRate + '% 券余 \n' + this.storageAssetsList.ksCouponAmountObj.amount + '万 \n}', itemStyle: { color: '#F56C40' }, type: this.storageAssetsList.ksCouponAmountObj.value },
                            { value: this.storageAssetsList.womanAmountObj.amount, name: '{c|女性特护 ' + this.storageAssetsList.womanRate + '%\n' + this.storageAssetsList.womanAmountObj.amount + '万 \n}', itemStyle: { color: '#F9B59F' }, type: this.storageAssetsList.womanAmountObj.value },
                            { value: this.storageAssetsList.functionAmountObj.amount, name: '{c|' + this.storageAssetsList.functionRate + '% 功能 \n' + this.storageAssetsList.functionAmountObj.amount + '万 \n}', itemStyle: { color: '#A8BCFE' }, type: this.storageAssetsList.functionAmountObj.value },
                            { value: this.storageAssetsList.rebirthAmountObj.amount, name: '{c|再生 ' + this.storageAssetsList.rebirthRate + '%\n' + this.storageAssetsList.rebirthAmountObj.amount + '万 \n}', itemStyle: { color: '#5678FF' }, type: this.storageAssetsList.rebirthAmountObj.value },
                        ]
                        radius = ['30%', '53%']
                    }
                    // 基于准备好的dom，初始化echarts实例
                    let myEcharts = this.$echarts.init(this.$refs.headchart);
                    window.onresize = myEcharts.resize;
                    let options = {
                        series: [
                            {
                                type: 'pie',
                                radius: radius,
                                // avoidLabelOverlap: false,  //备注隐藏
                                label: {
                                    show: true,
                                    // color: "#35434C",
                                    rich: {
                                        c: {
                                            padding: [6, 0, 0, 0],
                                            fontSize: window.innerWidth * 26 / 750,
                                            color: "#35434C",
                                            align: 'left',
                                        },
                                    },
                                },
                                labelLine:
                                {
                                    normal: {
                                        length: 25,
                                        length2: 20,
                                        lineStyle: {
                                            width: 2//设置线条粗细
                                        }
                                    }
                                },
                                data: data
                            }
                        ]
                    };
                    myEcharts.on('click', function (param) { //添加点击事件
                        console.log(param);
                        if (_this.dimension == 1) {
                            if (param.dataIndex == 0)   //生美护理
                            {
                                _this.$router.push({
                                    name: 'nursingBalanceAssets', query: {
                                        id: _this.checkedRegion.id,
                                        storeId: _this.checkedStore.id
                                    },
                                });
                            }
                            else if (param.dataIndex == 1)   //生美产品
                            {
                                _this.$router.push({
                                    name: 'productBalanceAssets', query: {
                                        id: _this.checkedRegion.id,
                                        storeId: _this.checkedStore.id
                                    },
                                });
                            }
                            else if (param.dataIndex == 2)   //卡余
                            {
                                _this.$router.push({
                                    name: 'cardBalanceAssets', query: {
                                        id: _this.checkedRegion.id,
                                        storeId: _this.checkedStore.id
                                    },
                                });

                            }
                            else if (param.dataIndex == 3)   //生美券余
                            {
                                _this.$router.push({
                                    name: 'voucherBalanceAssets', query: {
                                        id: _this.checkedRegion.id,
                                        storeId: _this.checkedStore.id
                                    },
                                });

                            }
                            else if (param.dataIndex == 4)   //医美/抗衰
                            {
                                _this.$router.push({
                                    name: 'medicalAestheticsAssets', query: {
                                        id: _this.checkedRegion.id,
                                        storeId: _this.checkedStore.id
                                    },
                                });

                            }
                        } else if (_this.dimension == 2) {
                            _this.$router.push({
                                name: 'medicalAssetList', query: {
                                    type: param.data.type,
                                    id: _this.checkedRegion.id,
                                    storeId: _this.checkedStore.id
                                },
                            });
                        } else if (_this.dimension == 3) {
                            _this.$router.push({
                                name: 'ksAssetList', query: {
                                    type: param.data.type,
                                    id: _this.checkedRegion.id,
                                    storeId: _this.checkedStore.id
                                },
                            });
                        }


                    });
                    myEcharts.setOption(options);
                });

            },
            //资产明细
            getDetail() {
                let params = null
                if (this.regionPostId.includes(this.postId)) {
                    params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                }
                return request({
                    url: '/debt/storeProperty',
                    method: "get",
                    params: params
                }).then((res) => {
                    this.storageAssetsList = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            onRefresh() {
                this.sellMonthAmountData = [];
                this.totalAmountData = [];
                this.refreshing = false;
                this.onLoad();
                this.initdateData();
            },
            //院内资产月份明细
            getSellAmountData() {
                let params = {
                    date: this.year
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: `/debt/storeYearSale`,
                    method: "get",
                    params: params
                }).then((res) => {
                    this.sellMonthAmountData = res.data.storeMonthSaleList;
                    this.totalAmountData = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 切换年份
            handleCalendar(handle) {
                const year = this.year;
                this.sellMonthAmountData = [];
                this.totalAmountData = [];
                if (handle === "prev") {
                    let newYear = year - 1;
                    this.year = newYear
                } else {
                    let newYear = year + 1;
                    this.year = newYear
                }
                this.getSellAmountData();
            },

            //查看明细
            toDetail() {
                this.$router.push({
                    name: "storageAssetsDetails", query: {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                });
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "storageAssetsRegionPage"
                        });
                    } else {
                        this.reload();
                    }
                })
            },
        },
    };
</script>

<style scoped lang="less">
    .store-box {
        padding: 30px 30px;
        height: 118px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .head-box {
        width: 750px;
        height: 248px;
        background: #f5f6f7;
        padding: 30px;

        .assets {
            margin-top: 30px;
        }

        .title-name {
            height: 48px;
            font-size: 34px;
            color: #35434c;
            line-height: 48px;
            margin-top: 22px;
        }

        .amount {
            height: 70px;
            font-size: 50px;
            font-weight: 700;
            color: #35434c;
            line-height: 70px;
        }

        .detail-box {
            width: 253px;
            height: 60px;
            background: #2fd0d5;
            border-radius: 45px;
            justify-content: center;
            margin-left: 20px;
        }

        .detail-name {
            height: 40px;
            font-size: 28px;
            color: #ffffff;
            line-height: 40px;
        }

        .head-arrow {
            width: 15px;
            height: 26px;
            font-size: 28px;
            color: #ffffff;
            margin-left: 10px;
        }
    }

    .storageassets-module {
        height: 100%;
        overflow-y: auto;
        padding-bottom: 30px;
    }

    .head-chart {
        height: 570px;
    }

    #headchart {
        height: 570px;
    }

    .interval {
        width: 750px;
        height: 20px;
        background: #f2f2f5;
        opacity: 0.5;
    }

    .date-box {
        padding: 30px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }

        .updatetime {
            height: 37px;
            font-size: 26px;
            color: #a0acb5;
            line-height: 37px;
        }
    }

    .table-list {
        padding: 0 30px 0 30px;

        .tr {
            display: flex;
            width: 100%;
            justify-content: center;
            height: 60px;
            align-items: center;
        }

        .tr-bottom {
            border-bottom: 1px solid #d7d7d7;
        }

        .th {
            width: 40%;
            justify-content: center;
            background: #fafafe;
            color: #66757f;
            display: flex;
            height: 80px;
            align-items: center;
            font-size: 26px;
        }

        .td {
            width: 40%;
            justify-content: center;
            text-align: center;
            font-size: 28px;
            color: #35434c;
        }

        .td-item {
            margin-bottom: 17px;
        }

        .line {
            height: 100px;
            font-size: 28px;
            color: #35434c;
            padding: 0 20px 0 20px;
        }

        .fc {
            color: red;
        }

        .table-header {
            height: 80px;
            background: #f2f2f5;
            border-radius: 4px;
            padding: 0 20px 0 20px;
            color: #66757f;
        }

        .header-title {
            min-width: 60px;
            height: 37px;
            font-size: 26px;
            line-height: 37px;
            text-align: center;
        }

        .header-title-ml70 {
            margin-left: 70px;
        }

        .header-title-ml35 {
            margin-left: 35px;
        }

        .data-list {
            background: #fff;
            // border-radius: 4px;
            padding: 0 20px 0 20px;
        }

        .total-td-title-ml {
            margin-left: 40px;
        }
    }

    .total {
        height: 100px;
        background: #f2f2f5;
        border-radius: 8px;
    }

    .total-tr {
        padding: 0 20px 0 20px;
    }

    .total-td {
        min-width: 60px;
        color: #35434c;
        font-weight: 700;
        font-size: 28px;
        text-align: center;
    }

    .van-pull-refresh {
        min-height: 100%;
    }
</style>
